<span class="sr-only" id="{{ctx.id}}-missing-fields-header">
  {{ ctx.t('Empty fields') }}
</span>
<ul class="utrecht-unordered-list openforms-soft-required-errors__missing-fields" aria-labelledby="{{ctx.id}}-missing-fields-header">
{% for (const label of ctx.labels) { %}
  <li class="utrecht-unordered-list__item">{{ label }}</li>
{% } %}
</ul>
